import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { loadAppConfig, getMsalConfig } from "./config/authConfig";
import { initApiEndpoints } from "./config/apiConfig";
import App from "./App";
import "./index.css";
async function bootstrap() {
    const config = await loadAppConfig();
    const msalConfig = getMsalConfig(config);
    const msalInstance = new PublicClientApplication(msalConfig);
    initApiEndpoints(config.apiBaseUrl);
    ReactDOM.createRoot(document.getElementById("root")).render(_jsx(React.StrictMode, { children: _jsx(MsalProvider, { instance: msalInstance, children: _jsx(App, {}) }) }));
}
bootstrap();
